import { useState } from 'react';

import { Button, Space, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import CallApi from '../../API_Utils/APIUtil/CallApi';
import { getError, validator } from '../../clientUtils';
import Uploader2 from '../../Components/Common/Uploader2';
import { FILE_TYPE_ATTRIBUTE } from '../../constants';
import apiConfig from '../../API_Utils/APIUtil/ApiConfig';

export default function BulkUploader({ onPrevious, sampleDownloadLink, jobId }) {
  const [SKUFiles, setSKUFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const nav = useNavigate();
  const SKUListUploadProps = {
    title: 'SKU List',
    description: 'Please upload the list of SKUs (in CSV format with max file size of 5 MB)',
    sampleDownloadText: 'Download Sample file',
    sampleDownloadLink,
    accept: FILE_TYPE_ATTRIBUTE.csv,
    files: SKUFiles,
    validator,
    onUpload: (file) => {
      CallApi(
        { ...apiConfig.reorderSKUFileValidate, path: apiConfig.reorderSKUFileValidate.path(jobId) },
        undefined,
        { file, wms: 'Unicom', tenant: 'implexians', facility: 'Implexians_ADK', reportName: 'Reorder Report' },
        undefined,
        (res) => setSKUFiles([res]),
        (res) => message.error(getError(res))
      );
    },
    onRemove: async () => {
      setSKUFiles([]);
      message.success('File deleted successfully!');
    }
  };
  const uploaderProps = {
    message: 'Please upload file for Bulk Purchase Request Creation',
    items: [SKUListUploadProps]
  };

  const onSave = () => {
    CallApi(
      { ...apiConfig.reorderSubmitFile, path: apiConfig.reorderSubmitFile.path(jobId) },
      undefined,
      {
        action: 'create',
        files: [
          {
            file_id: SKUFiles[0].file_id,
            file_type: 'PO_REORDER_VALIDATE'
          }
        ]
      },
      setSaving,
      () => {
        message.success('Reorder data submitted successfully. Purchase Request will be created shortly');
        nav('/purchases/purchase-request');
      },
      (res) => message.error(getError(res))
    );
  };

  const ifSaveDisabled = () => {
    if (!SKUFiles || !SKUFiles.length || SKUFiles.length < 1) return true;
    if (SKUFiles[0]?.summary?.failure > 0) return true;
    return false;
  };
  return (
    <Space direction="vertical">
      <Uploader2 items={uploaderProps.items} message={uploaderProps.message} />
      <Space className="btns-container">
        <Button onClick={onPrevious}>Previous</Button>
        <Button onClick={onSave} type="primary" disabled={ifSaveDisabled()} loading={saving}>
          Submit
        </Button>
      </Space>
    </Space>
  );
}
